/**
 * 新規登録機能専用
 */
import httpDao from "../infrastructure/httpDao";
import { AxiosResponse } from "axios";
import { RegisterAccountParams, SignupParams } from "../types/common";

export const newRegistrationRepository = {
  signup: async (params: SignupParams): Promise<AxiosResponse> => {
    const res = await httpDao.post("/auth/staff/signup", params);
    return res;
  },

  verifyCode: async (code: string): Promise<AxiosResponse> => {
    const res = await httpDao.post("/auth/staff/verify-code", { code });
    return res;
  },

  resendVerification: async (email: string): Promise<AxiosResponse> => {
    const res = await httpDao.post("/auth/staff/resend-verification", {
      email,
    });
    return res;
  },

  register: async (params: RegisterAccountParams): Promise<AxiosResponse> => {
    const res = await httpDao.post("/staff/profile", params);
    return res;
  },

  sendPaymentTokenId: async (params: {
    id: string;
    token_id: string;
  }): Promise<AxiosResponse> => {
    const res = await httpDao.post("/payment/card-token", params);
    return res;
  },

  // 郵便番号検索API（日本郵便公開API）
  fetchAddress: async (postalCode: string): Promise<AxiosResponse> => {
    const res = await httpDao.get(
      `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`
    );
    return res;
  },
};
